import graphql from './graphql';

const mutation = /* GraphQL */ `
  mutation UserEvaluation_delete($id: ID!, $userId: ID!, $courseId: ID!) {
    UserEvaluation_delete(id: $id, userId: $userId, courseId: $courseId)
  }
`;

const UserEvaluationDelete = async ({ id, userId, courseId }) =>
  graphql(mutation, {
    id,
    userId,
    courseId,
  }).then(
    // eslint-disable-next-line camelcase
    ({ UserEvaluation_create }) => UserEvaluation_create
  );

export default UserEvaluationDelete;
